import React, { useState, useEffect } from 'react';
import { MdHistory } from 'react-icons/md';
import { RiSendPlaneFill } from 'react-icons/ri';
import { connect } from 'react-redux';

import DataTable from 'common-components/DataTable';
import Alert from 'common-components/Alert';
import { SERVER_ERROR, LOGIN_ERROR } from 'common-components/Alert/alertMessage.config';
import { setExistingCategories } from 'redux/categories/cat.actions';
import ViewCategoryHistory from '../ViewCategoryHistory';
import { isInputValid } from '../../utils';
import axiosInstance from 'axios-config';
import { columns } from './categoryTableColumns';

import './categoryTable.style.css';


const CategoryTable = ({
  currentUser,
  priviledge,
  authHeader,
  existingCategories,
  setExistingCategories
}) => {
  const [tableRowData, setTableRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [alertData, setAlertData] = useState({});
  const [categoriesToPost, setCategoriesToPost] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [catIdToView, setCatIdToView] = useState(null);

  useEffect(() => {
    if (existingCategories) {
      setTableRowData(existingCategories);
      setIsLoading(false);
    } else {
      getAllCategoriesFromDb();
    }

    if (!columns.some(
      column => { return column.title === "Status" })) {

      columns.push(
        {
          title: "Status",
          key: "status",
          headerClassName: 'status',
          render: (row) => {
            if (row.status === 2) return <div className='status-container rejected'>Rejected</div>;
            if (row.status === 0) return <div className='status-container pending'>Pending</div>;
            else return <div className='status-container success'>Published</div>;
          },
        }
      );
    };
  }, [existingCategories]);


  const getAllCategoriesFromDb = async () => {
    setIsLoading(true);

    await axiosInstance.get("/category",
      { headers: authHeader })
      .then((response) => {
        if (response.status.toString().match(/2\d{2}/)) {
          setExistingCategories(response.data.results);
        } else {
          console.log(response);
          setAlertData(SERVER_ERROR);
        };
      })
      .catch((error) => {
        console.log(error);
        let _s = error.message.split(' ')
        let status = parseInt(_s[_s.length - 1])
        if (status == 401) {
          setAlertData(LOGIN_ERROR);
        } else setAlertData(SERVER_ERROR);
      });

    setIsLoading(false);
  };

  const postCategory = (category) => {
    return axiosInstance.post("/category/", category, { headers: authHeader })
      .then((response) => {
        if (response.status.toString().match(/2\d{2}/)) {
          setTableRowData((prevData) => {
            let updatedData = [...prevData];
            updatedData.map((cat) => {
              if (cat.detailed_category_id === category.detailed_category_id) {
                cat.status = 1;
                cat.created_timestamp = response.data.created_timestamp.replace('T', ' ').replace(/\.[0-9]*Z/i, "");
              };
            })
            return [...updatedData];
          });

          setCategoriesToPost((prevCats) => {
            return prevCats.filter(cat => cat.detailed_category_id !== category.detailed_category_id)
          });
        } else {
          console.log(response);
          setAlertData(SERVER_ERROR);
        };
      })
      .catch((error) => {
        let _s = error.message.split(' ')
        let status = parseInt(_s[_s.length - 1])

        console.log(error)

        setTableRowData((prevData) => {
          let updatedData = [...prevData];
          updatedData.map((cat) => {
            if (cat.detailed_category_id === category.detailed_category_id) {
              cat.status = 2;
            };
          });
          return [...updatedData];
        });

        setCategoriesToPost((prevCats) => {
          return prevCats.filter(cat => cat.detailed_category_id !== category.detailed_category_id)
        });

        if (status == 401) {
          setAlertData(LOGIN_ERROR);
        } else setAlertData(SERVER_ERROR);
      });
  };

  const addCategory = (data, timeout = 500) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setTableRowData((prevData) => {
          return [data, ...prevData];
        });

        setCategoriesToPost((prevData) => {
          return [data, ...prevData];
        });
        resolve(true);
      }, timeout);
    });
  };

  const addAction = async (row) => {
    row.detailed_category_id = row.detailed_category_id.toString().trim()
    row.detailed_category_name = row.detailed_category_name.trim()

    const response = isInputValid(row, tableRowData, true)

    if (response.status) {
      const updatedData = { ...row };
      updatedData.status = 0;
      updatedData.users = currentUser;
      updatedData.row_id = tableRowData.length;
      return await addCategory(updatedData);
    }
    else {
      setAlertData({
        title: "Invalid data inserted",
        description: response.errorMsg,
        eventName: "Ok! I won't do that again",
        showModal: true,
        type: 'error'
      })
    };
  };

  const actionComponents = ({ row, rowIndex, showLoader, hideLoader }) => {
    let { detailed_category_id } = row;

    if (row.status === 0) {
      return (
        <>
          <div className='tooltip'>
            <div className="tooltiptext">History</div>
            <span>
              <MdHistory className='view' onClick={() => {
                setCatIdToView(detailed_category_id);
                setShowModal(prev => !prev);
              }} />
            </span>
          </div>
          <div className='tooltip'>
            <div className="tooltiptext">Send</div>
            <span>
              <RiSendPlaneFill className='sync-all' onClick={async () => {
                showLoader();
                await postCategory(row);
                hideLoader();
              }} />
            </span>
          </div>
        </>
      );
    };

    return (
      <div className='tooltip'>
        <div className="tooltiptext">History</div>
        <span>
          <MdHistory className='view' onClick={() => {
            setCatIdToView(detailed_category_id);
            setShowModal(prev => !prev)
          }} />
        </span>
      </div>
    );
  };

  const updateRow = (row, timeout = 400) => {
    return new Promise((resolve) => {
      setTimeout(() => {

        setTableRowData((prevData) => {
          let updatedData = [...prevData];
          const index = updatedData.findIndex(({ row_id }) =>
            row_id === row.row_id);
          updatedData[index] = row;
          return [...updatedData];
        });

        resolve(true);
      }, timeout);
    });
  };

  const listRowForBulkPost = (data) => {
    setCategoriesToPost((prevData) => {
      return [data, ...prevData];
    });
  };

  const editAction = async (row) => {
    row.detailed_category_id = row.detailed_category_id.toString().trim()
    row.detailed_category_name = row.detailed_category_name.trim()

    const inputNotChanged = tableRowData.some(elm =>
      (elm.detailed_category_id == row.detailed_category_id)
      && (elm.detailed_category_name == row.detailed_category_name));
    const response = isInputValid(row, tableRowData);

    if (inputNotChanged) {
      setAlertData({
        title: "Information",
        description: "You have not made any changes in input fields.",
        eventName: 'Thanks!',
        showModal: true,
        type: 'info',
      });
    } else if (!response.status) {
      setAlertData({
        title: "Invalid data inserted",
        description: response.errorMsg,
        eventName: "Ok! I won't do that again",
        showModal: true,
        type: 'error'
      });
    } else {
      row.status = 0;
      listRowForBulkPost(row);
      return await updateRow(row);
    }
  };

  const postAllEditedCat = async () => {
    let requets = [];
    for (let i = 0; i < categoriesToPost.length; i++) {
      requets.push(postCategory(categoriesToPost[i]));
    };
    return Promise.all(requets);
  };

  const syncAll = () => postAllEditedCat();

  return (
    <>
      <div className='category-table-container'>
        <DataTable
          title="CATEGORIES"
          wrapperClassName='main-cat-table'
          rows={tableRowData}
          columns={columns}
          pageSizeOptions={[10, 15, 25, 50]}
          searchableFields={["detailed_category_name", "detailed_category_id", "users"]}
          onEdit={priviledge.is_admin ? editAction : null}
          onAdd={priviledge.is_admin ? addAction : null}
          ActionComponent={actionComponents}
          isLoading={isLoading}
          onSync={categoriesToPost.length > 0 && syncAll}
        />
      </div>
      {showModal && (
        <ViewCategoryHistory
          showModal={showModal}
          setShowModal={setShowModal}
          catID={catIdToView}
        />
      )}
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </>
  )
};

const mapStateToProps = ({
  categories: { existingCategories },
  authentication: { currentUser, authHeader, priviledge } }) => ({
    currentUser,
    authHeader,
    priviledge,
    existingCategories
  });

const mapDispatchToProps = dispatch => ({
  setExistingCategories: categories => dispatch(setExistingCategories(categories)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryTable);
